var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColorModeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.46331C11.062 8.46331 10.1624 8.83592 9.49918 9.49918C8.83592 10.1624 8.46331 11.062 8.46331 12C8.46331 12.938 8.83592 13.8376 9.49918 14.5008C10.1624 15.1641 11.062 15.5367 12 15.5367C12.938 15.5367 13.8376 15.1641 14.5008 14.5008C15.1641 13.8376 15.5367 12.938 15.5367 12C15.5367 11.062 15.1641 10.1624 14.5008 9.49918C13.8376 8.83592 12.938 8.46331 12 8.46331ZM12 17.305C10.593 17.305 9.24366 16.7461 8.24877 15.7512C7.25388 14.7563 6.69496 13.407 6.69496 12C6.69496 10.593 7.25388 9.24366 8.24877 8.24877C9.24366 7.25388 10.593 6.69496 12 6.69496C13.407 6.69496 14.7563 7.25388 15.7512 8.24877C16.7461 9.24366 17.305 10.593 17.305 12C17.305 13.407 16.7461 14.7563 15.7512 15.7512C14.7563 16.7461 13.407 17.305 12 17.305ZM19.0734 9.07339V4.92661H14.9266L12 2L9.07339 4.92661H4.92661V9.07339L2 12L4.92661 14.9266V19.0734H9.07339L12 22L14.9266 19.0734H19.0734V14.9266L22 12L19.0734 9.07339Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorModeLight);
export default __webpack_public_path__ + "static/media/icon-color-mode-light.af4df7aa24b82f64b7187ef839d44ee2.svg";
export { ForwardRef as ReactComponent };